import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { UploadDocumentLabels } from "@/domain/types/document";

export function useUploadDocumentLabels(): UploadDocumentLabels {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      title: t("document_upload.title"),
      type: t("document_upload.type"),
      file: t("document_upload.file"),
      fileHint: t("document_upload.file_hint"),
      cancel: t("common.cancel"),
      upload: t("document_upload.upload"),
    }),
    [t],
  );
}
